import React, { useState } from "react";
import "../../css/view-mail/Sidebar.css";

const Sidebar = () => {
  return (
    <div className="view-mail-sidebar">
      <div className="sidebar-header">
        <div className="custom-text">
          PM210012-LTG530-MCR-WIR-CIV-00739 T...
        </div>
        <div className="email">EMAIL</div>
      </div>

      <div className="sidebar-section">
        <div className="header">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 20 20"
              stroke="#949494"
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M 10 17.5 C 14.1421 17.5 17.5 14.1421 17.5 10 C 17.5 5.85786 14.1421 2.5 10 2.5 C 5.85786 2.5 2.5 5.85786 2.5 10 C 2.5 14.1421 5.85786 17.5 10 17.5 Z" />
            </svg>
          </div>
          <div className="section">
            <div className="text1">Document Control NeomGeneration</div>
            <div className="sub-section">
                <div className="text2">LTGEN-EMAIL-021523</div>
                <div className="date">5:47 PM</div>
            </div>
            <div className="text3">LARSEN & TOUBOR SAUDI ARABIA LLC</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
